<ng-container *ngIf=" (inputConfig$ | async) as inputConfig">
    <p-treeSelect 
    class="md:w-20rem w-full" 
    containerStyleClass="w-full" 
    [(ngModel)]="selectedNode" 
    [options]="klasaArray$ | async" 
    placeholder="<Odaberite klasu>"
    [filter]="true"
    [filterInputAutoFocus]="true"
    (onNodeSelect)="onNodeSelect($event)"
    (onClear)="clearSelection()"
    showClear="true"
    [ngClass]="{ readonly: inputConfig.readOnly }"
    [disabled]="inputConfig.disabled"/>
</ng-container>